import type { CombinedError } from 'urql';

// Mirror of the backend's USER_ERROR_CODES (bts-web/src/user/errors.ts).
// These are part of the GraphQL contract — keep in sync. Backend wording
// can change freely; frontend only switches on the code.
export const USER_ERROR_CODES = {
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
} as const;

type UserErrorCode = (typeof USER_ERROR_CODES)[keyof typeof USER_ERROR_CODES];

const TRANSLATIONS: Record<UserErrorCode, string> = {
  [USER_ERROR_CODES.USER_ALREADY_EXISTS]:
    'Für diese E-Mail existiert bereits ein Benutzer (auch bei abweichender Groß-/Kleinschreibung).',
};

const isKnownCode = (value: unknown): value is UserErrorCode =>
  typeof value === 'string' && value in TRANSLATIONS;

export const describeUserBackendError = (
  error: CombinedError | undefined,
  fallback: string,
): string => {
  const code = error?.graphQLErrors[0]?.extensions?.code;
  if (isKnownCode(code)) return TRANSLATIONS[code];
  return error?.graphQLErrors[0]?.message ?? error?.message ?? fallback;
};
